// src/utils/stageUtils.ts
import { Stage } from '../constants/configurations';
import { WEBSITE_ENDPOINTS } from '../constants/endpoints';

export const getStageFromUrl = (): Stage => {
  if (typeof window === 'undefined') {
    return Stage.PROD; // Default to PROD if not in browser environment
  }

  const hostname = window.location.hostname.toLowerCase();
  console.log('Current hostname:', hostname);

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === 'localhost.a2z.com') {
    return Stage.DEV;
  }

  // Find matching stage based on endpoint hostnames
  for (const [stage, endpoint] of Object.entries(WEBSITE_ENDPOINTS)) {
    if (endpoint) {
      try {
        const endpointHostname = new URL(endpoint).hostname.toLowerCase();
        if (hostname === endpointHostname) {
          return stage as Stage;
        }
      } catch {
        console.warn(`Invalid endpoint URL for stage ${stage}: ${endpoint}`);
      }
    }
  }

  // If no matches found, return PROD as default
  return Stage.PROD;
};
